var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Leading icon?"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9097 0.5C9.83141 0.5 7.82681 1.96553 7.82681 5.08546V7.36686H1.64348C0.538001 7.36686 0 7.92587 0 9.14212V14.7247C0 15.9485 0.538001 16.5 1.64348 16.5H8.79226C9.89774 16.5 10.4357 15.9485 10.4357 14.7247V9.14212C10.4357 8.00897 9.97144 7.44995 9.01336 7.38196V4.92682C9.01336 2.7814 10.3694 1.65581 11.9097 1.65581C13.4574 1.65581 14.8134 2.7814 14.8134 4.92682V6.66431C14.8134 7.20066 15.0714 7.42729 15.4104 7.42729C15.7347 7.42729 16 7.22332 16 6.68697V5.08546C16 1.96553 13.988 0.5 11.9097 0.5ZM8.74067 8.50755C9.08706 8.50755 9.24919 8.65864 9.24919 9.07413V14.7852C9.24919 15.2082 9.08706 15.3669 8.74067 15.3669H1.69507C1.35606 15.3669 1.18655 15.2082 1.18655 14.7852V9.07413C1.18655 8.65864 1.35606 8.50755 1.69507 8.50755H8.74067Z",
    fill: "#414141"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockIcon);
export default __webpack_public_path__ + "static/media/unlockIcon.4bb75eeb93e1d3061588e38e15b8fbc5.svg";
export { ForwardRef as ReactComponent };